import { ParentescoEnum } from './../dominios/enum/parentesco.enum';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'parentescoPipe'
})
export class ParentescoPipe implements PipeTransform {

    transform(value: number) {
        return ParentescoEnum.values.find(parentesco => parentesco.value  ===  value).label
    }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/pipe/parentesco.pipe.ts